import { render, staticRenderFns } from "./coupon-form.vue?vue&type=template&id=478a0f10"
import script from "./coupon-form.vue?vue&type=script&lang=js"
export * from "./coupon-form.vue?vue&type=script&lang=js"
import style0 from "./coupon-form.vue?vue&type=style&index=0&id=478a0f10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports